export const GActions = {
  Signin: 'Sign In Click',
  StartFree: 'Start Free Click',
  ContactSales: 'Contact Sales Click'
};

export const GLabels = {
  Banner: 'Banner',
  Topbar: 'Topbar',
  MobileMenu: 'MobileMenu',
  JoinTrail: 'Join Trail',
  Pricing: 'Pricing',
};


export function sendEvent({ url, action, category = 'engagement', label }) {
  return (e) => window.ga('send', 'event', 'engagement', action, label, 0);
  // return (e) => {
  //   e.preventDefault();
  //   e.stopPropagation();
  //   // let url = e.target.href;
  //   // console.log(action, label, 'tracked');
  //   // console.log("e: ", e.target);

  //   // setTimeout(redirect, 1000);

  //   let redirected = false;

  //   function redirect() {
  //     if (!redirected) {
  //       redirected = true;
  //       document.location.href = url;
  //     }
  //   }

  //   if (window.gtag && window.google_tag_manager) {
  //     window.gtag('event', action, {
  //       'event_label': label,
  //       'event_category': category,
  //       'event_callback': () => {
  //         // console.log("document.location.href", document.location.href, url, window.gtag);
  //         redirect();
  //       }
  //     });
  //   } else {
  //     redirect();
  //   }



  // }
}
